import React, { forwardRef, useEffect } from 'react';

import { useAuth } from 'contexts/auth';
import { FeedbackTile, RichTextInput, Stack, Text } from 'shell/components';
import { getUserPreferredFullName } from 'utils/helper';

const SubmissionCommentSection = forwardRef(
    (
        {
            submissions,
            getUserByAccountId,
            handleSelect,
            currentEditingComment,
            setCurrentEditingComment,
            handleAddComment,
            handleEditComment,
        },
        ref
    ) => {
        const { auth } = useAuth();

        useEffect(() => {
            if (ref.current.props.editor) {
                ref.current.props.editor.commands.clearContent();
                setCurrentEditingComment(null);
            }
        }, [submissions?.[0]?.id]);

        useEffect(() => {
            if (ref.current && ref.current.props.editor) {
                ref.current.props.editor.commands.setContent(currentEditingComment ? currentEditingComment.text : '');
            }
        }, [currentEditingComment]);

        return (
            <>
                <Text variant={'p2'}>Comments ({submissions[0].comments.length})</Text>
                {submissions[0].comments.length ? (
                    <Stack spacing={2}>
                        {submissions[0].comments.map((comment) => (
                            <FeedbackTile
                                key={comment.id}
                                author={getUserByAccountId(comment.owner_account_id)}
                                feedback={comment}
                                getNameById={(id) => getUserPreferredFullName(getUserByAccountId(id))}
                                options={
                                    comment.owner_account_id === auth.owner_account_id
                                        ? [
                                              { key: 'edit', value: 'Edit' },
                                              { key: 'delete', value: 'Delete' },
                                          ]
                                        : []
                                }
                                onSelect={({ key }) => handleSelect(key, comment)}
                            />
                        ))}
                    </Stack>
                ) : null}
                <RichTextInput
                    ref={ref}
                    defaultShowFormatting={false}
                    disableUpload
                    isEditing={Boolean(currentEditingComment)}
                    placeholder={'Add Comment'}
                    onClickCancelEdit={() => setCurrentEditingComment(null)}
                    onSend={(html) => {
                        if (currentEditingComment) {
                            handleEditComment(html);
                        } else {
                            handleAddComment(html);
                        }
                    }}
                />
            </>
        );
    }
);

export default SubmissionCommentSection;
